export var FontSizes;

(function (FontSizes) {
  FontSizes.size10 = '10px';
  FontSizes.size12 = '12px';
  FontSizes.size14 = '14px';
  FontSizes.size16 = '16px';
  FontSizes.size18 = '18px';
  FontSizes.size20 = '20px';
  FontSizes.size24 = '24px';
  FontSizes.size28 = '28px';
  FontSizes.size32 = '32px';
  FontSizes.size42 = '42px';
  FontSizes.size68 = '68px';
})(FontSizes || (FontSizes = {}));